import { Helmet } from "react-helmet-async";

const SITE_NAME = "Sandeep Varikuppala — Frontend Developer";
const DEFAULT_DESC =
  "Sandeep Varikuppala — Senior Frontend Developer & UI Engineer based in India, specialized in building premium, responsive portfolio sites, React/Next.js architectures, and full-stack MERN developments. Explore case studies and tech articles.";
const SITE_URL = (process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
const DEFAULT_IMAGE = `${SITE_URL}/images/twitter-card.png`;

const defaultPersonLd = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Sandeep Varikuppala",
  "url": SITE_URL,
  "jobTitle": "Senior Frontend Developer & UI/UX Engineer",
  "description": DEFAULT_DESC,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Hyderabad",
    "addressCountry": "IN"
  },
  "knowsAbout": ["React", "Next.js", "TypeScript", "Tailwind CSS", "MERN Stack", "Web Performance", "Accessibility (a11y)", "Design Systems"]
};

const defaultWebSiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Sandeep Varikuppala Portfolio",
  "url": SITE_URL
};

export function Seo({
  title,
  description = DEFAULT_DESC,
  image = DEFAULT_IMAGE,
  path = "",
  type = "website",
  jsonLd,
  noIndex = false,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="Sandeep Varikuppala, React Developer Hyderabad, Frontend Developer Portfolio, Next.js Developer India, React Freelancer India, UI Engineer Portfolio" />
      {noIndex ? <meta name="robots" content="noindex,nofollow" /> : <meta name="robots" content="index,follow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Schema Data */}
      <script type="application/ld+json">{JSON.stringify(defaultPersonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(defaultWebSiteLd)}</script>
      {jsonLd && (Array.isArray(jsonLd)
        ? jsonLd.map((schema, index) => (
            <script key={index} type="application/ld+json">
              {JSON.stringify(schema)}
            </script>
          ))
        : (
          <script type="application/ld+json">
            {JSON.stringify(jsonLd)}
          </script>
        )
      )}
    </Helmet>
  );
}

export { SITE_NAME, SITE_URL };
